import jwt from "jsonwebtoken";

export default {
  methods: {
    verificarSessao() {
      clearTimeout(this._sessaoTimer);
      const { auth, user } = this.$store.state.auth;
      if (!auth || !user) {
        this.$store.dispatch("auth/verify");
        return false;
      }

      const payload = jwt.decode(auth);
      if (!payload || typeof payload.exp !== "number" || !Number.isFinite(payload.exp) || payload.exp * 1000 <= Date.now()) {
        if (this.$route.name !== "logout") this.$router.push("/logout");
        return false;
      }

      const restante = payload.exp * 1000 - Date.now();
      this._sessaoTimer = setTimeout(this.verificarSessao, Math.min(restante, 2147483647));
      return true;
    },
    iniciarVerificacaoSessao() {
      if (!this.verificarSessao()) return false;
      document.addEventListener("visibilitychange", this.verificarSessao);
      return true;
    },
  },
  watch: {
    "$store.state.auth.auth"() {
      this.verificarSessao();
    },
  },
  beforeDestroy() {
    clearTimeout(this._sessaoTimer);
    document.removeEventListener("visibilitychange", this.verificarSessao);
  },
};
